// Warms up the network connection to the checkout origin (DNS lookup +
// TCP handshake + TLS negotiation) BEFORE the user clicks through, so the
// final navigation to Shopify/checkout starts transferring sooner.
//
// IMPORTANT — what this does NOT do (by design):
//  - Does NOT fetch the checkout or any cart URL.
//  - Does NOT create carts or build permalinks ahead of time.
//  - Does NOT fire any analytics/Pixel events.
//  - Does NOT open new tabs.
// It ONLY injects <link rel="dns-prefetch"> and <link rel="preconnect">
// for the checkout ORIGIN — purely the connection-setup phase.

// Origin only (no path) — matches SHOPIFY_CART_DOMAIN's host in App.tsx.
const CHECKOUT_ORIGIN = 'https://impulsodigital.vip'

// Module-level guard makes the whole operation idempotent: once the hints
// are in the document, every later call is a cheap no-op.
let warmed = false

export function warmCheckoutConnection(): void {
  if (warmed) return
  if (typeof document === 'undefined') return
  warmed = true

  // Avoid duplicating hints if one somehow already exists in the head.
  const alreadyPresent = document.head.querySelector(
    `link[rel="preconnect"][href="${CHECKOUT_ORIGIN}"]`,
  )
  if (alreadyPresent) return

  // dns-prefetch: resolves DNS early (broad browser support, cheap fallback).
  const dns = document.createElement('link')
  dns.rel = 'dns-prefetch'
  dns.href = CHECKOUT_ORIGIN
  document.head.appendChild(dns)

  // preconnect: opens the TCP + TLS connection ahead of the navigation.
  // No crossorigin attribute so the warmed connection is the one reused for
  // the top-level document navigation to the checkout.
  const pre = document.createElement('link')
  pre.rel = 'preconnect'
  pre.href = CHECKOUT_ORIGIN
  document.head.appendChild(pre)
}
